import { __decorate } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { DIY } from '@/helpers/constants/Store';
import { Mutation, Getter } from 'vuex-class';
let DiyRouterLeaveGuard = class DiyRouterLeaveGuard extends Vue {
    constructor() {
        super(...arguments);
        this.allowToLeave = false;
        this.to = '';
    }
    continueNavigation() {
        this.hideConfirmation();
        this.allowNavigation();
        const url = this.to || '/apps';
        this.$router.push(url);
    }
    created() {
        this.restrictNavigation();
    }
};
__decorate([
    Mutation('allowNavigation', { namespace: DIY })
], DiyRouterLeaveGuard.prototype, "allowNavigation", void 0);
__decorate([
    Getter('next', { namespace: DIY })
], DiyRouterLeaveGuard.prototype, "next", void 0);
__decorate([
    Mutation('restrictNavigation', { namespace: DIY })
], DiyRouterLeaveGuard.prototype, "restrictNavigation", void 0);
__decorate([
    Mutation('showConfirmation', { namespace: DIY })
], DiyRouterLeaveGuard.prototype, "showConfirmation", void 0);
__decorate([
    Mutation('hideConfirmation', { namespace: DIY })
], DiyRouterLeaveGuard.prototype, "hideConfirmation", void 0);
DiyRouterLeaveGuard = __decorate([
    Component({
        beforeRouteLeave(to, from, next) {
            const self = this;
            if (self.next) {
                next();
            }
            else {
                self.to = to.fullPath;
                self.showConfirmation();
            }
        },
    })
], DiyRouterLeaveGuard);
export default DiyRouterLeaveGuard;
